/**
 * 將語系 code 正規化為 API 使用的 lang_code（繁中統一 zh_TW）。
 */
export function resolveNewsApiLang(locale = 'en_US') {
  const code = String(locale || '').trim();
  if (!code) {
    return 'en_US';
  }
  if (code === 'zh_HK') {
    return 'zh_TW';
  }
  return code;
}
